import { DrawerNavigationProp } from "@react-navigation/drawer";
import { MainStackParamList } from "../../navigation/Navigation.types";
import { useCallback, useLayoutEffect, useState } from "react";
import { useAlert } from "@grassrootly/rn-core";
import useBaseRequest from "../../api/BaseRequest";
import { AddPlayerToGroupByEmail, AddPlayerToGameByEmail } from "@grassrootly/api";
import { IAddPlayerForm } from "./AddPlayer.types";

export function useAddPlayer({
  navigation,
  id,
  whereToAdd,
}: {
  navigation: DrawerNavigationProp<MainStackParamList, "add-player", undefined>;
  id: number;
  whereToAdd: "group" | "game";
}) {
  const { success } = useAlert();

  const { loading: addingToGroup, execute: addToGroup } = useBaseRequest(AddPlayerToGroupByEmail, {
    onCompleted(data, payload) {
      if (!data) return;
      success({ title: "Success", message: "Player successfully added!" });
      navigation.reset({
        index: 1,
        routes: [{ name: "my-groups" }, { name: "group", params: { id: id } }],
      });
    },
  });

  const { loading: addingToGame, execute: addToGame } = useBaseRequest(AddPlayerToGameByEmail, {
    onCompleted(data, payload) {
      if (!data) return;
      success({ title: "Success", message: "Player successfully added!" });
      navigation.reset({
        index: 1,
        routes: [
          { name: "game", params: { id: id } },
          { name: "edit-game", params: { id: id } },
        ],
      });
    },
  });

  const onAddPlayer = useCallback(
    (form: IAddPlayerForm) => {
      if (whereToAdd === "group") {
        addToGroup({ ...form, group_id: id });
        return;
      }
      addToGame({ ...form, game_id: id });
    },
    [id]
  );
  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate(whereToAdd, { id });
  };

  const [loadingForm, setLoadingForm] = useState(false);
  useLayoutEffect(() => {
    setLoadingForm(true);
    const timeout = setTimeout(() => {
      setLoadingForm(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, []);
  return { adding: addingToGame || addingToGroup, onAddPlayer, goBack, loadingForm };
}
